<template>
  <ul :class="itemClass" v-if="checkRouterAccess()" class="item-collapse">
    <li class="dashboard text-white " v-b-toggle="`collapse-${id}`" @click="customAction">

      <template v-if="children.length">
        <div class="text-white menu-item my-4">

          <b-icon class="ml-1" :icon="icon"></b-icon>
          {{ name }}
          <b-icon v-if="children.length > 0" icon="arrow-down-circle" class="d-inline mx-2"></b-icon>
        </div>
      </template>
      <template v-else>
        <router-link class="text-white menu-item" :to="route">

          <b-icon class="ml-1" :icon="icon"></b-icon>
          {{ name }}
        </router-link>
      </template>


    </li>

    <SubItem v-if="children.length"
             :id="id"
             :step="1"
             :children="children"
    />

  </ul>
</template>

<script>
import SubItem from './subItem'
import {findAttributeOnSiteInfo} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/FindAttributeOnSiteInfo";
import {mapGetters} from "vuex";

export default {
  name: "item",
  components: {SubItem},
  props: ['name', 'icon', 'route', 'children', 'id', 'action', 'access', 'itemClass'],
  computed: {
    ...mapGetters({
      isStore: "User/isUserStore"
    })
  },
  methods: {
    customAction() {
      if (this.action !== undefined) {
        this.action()
      }
    },
    checkRouterAccess() {
      let userProfile = this.$store.getters['User/getProfile'];

      if (findAttributeOnSiteInfo('store_access_to_content_management')[0] == 1 && this.name == 'مدیریت محتوا' && this.isStore) {
        return false
      }

      if (this.access.length === 0) {
        return true
      }
      let userAccessNumber = `${userProfile.role}-${userProfile.type}`
      return this.access.indexOf(userAccessNumber) > -1
    }
  }
}
</script>

<style scoped>
.dashboard {
  padding-right: 1rem;
  text-align: right;
  text-decoration: none;
  cursor: pointer;
}


ul li {
  list-style: none;
  color: #fff;
}


ul li a {
  color: #ffffff;
  text-decoration: none;
  display: block;
  padding: 15px 0 15px 10px;
  font-size: 16px;
  outline: none;
}

@media only screen and (max-width: 991px) {
  ul li a {
    color: #fff;
  }
}


</style>